import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function AboutExWeapons() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        onClick={handleClickOpen}
        variant="contained"
        style={{ borderRadius: 30 }}
        color="success"
      >
        Exclusive Weapons Info (PLS Read)
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Ex Weapons
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            First things first, this is based on CN server data, so.. all this
            might change or not! The info is NOT mine, i just sharing, credits
            to whom it may concern
          </Typography>

          <Typography gutterBottom>
            <strong>
              Exclusive (EX) weapons are character-unique weapons that can be
              acquired in 2 ways:
            </strong>
          </Typography>
          <Typography gutterBottom>
            1) Equipment Summon (weapon gacha) for 100 souls per summon (except
            Celanya's)
          </Typography>
          <Typography gutterBottom>
            2) From shop using 2000 Miracle Crystal one time only per ex
            equipment (except Celanya's), this means you can get 1 copy of ex
            weapon only playing , no need to spend money!
          </Typography>
          <Typography gutterBottom>
            <strong>Additional information:</strong>
          </Typography>
          <Typography gutterBottom>
            1) EX Weapons are a 4th and additional equipment to that character.
            They will not replace existing weapons.
          </Typography>
          <Typography gutterBottom>
            2) EX Weapons can be ascended every 10 levels. Doing so will also
            improve the effect on the weapon.
          </Typography>
          <Typography gutterBottom>
            3) Necessary materials for all ascensions can be bought from the
            same shop where you buy the EX Weapons.
          </Typography>
          <Typography gutterBottom>
            4) A dupe is needed to ascend to level 21. Further ascensions after
            that do not require additional dupes. You only need 1 dupe to fully
            ascend an EX weapon.
          </Typography>
          <Typography gutterBottom>
            5) Each character's EX Weapon provides different stat gains.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cerrar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
